import React, { useCallback, useState } from 'react';
import { readCookieConsent, writeCookieConsent } from './cookieConsentStorage';
import { loadYandexMetrika } from './yandexMetrika';

const CookieConsentBanner = () => {
    const [visible, setVisible] = useState(() => readCookieConsent() === null);
    const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

    const apply = useCallback((analytics) => {
        writeCookieConsent({ v: 1, analytics });
        if (analytics) {
            loadYandexMetrika();
        }
        setVisible(false);
    }, []);

    if (!visible) {
        return null;
    }

    return (
        <div className="cookie-banner" role="dialog" aria-label="Файлы cookie">
            <div className="cookie-banner__card">
                <p className="cookie-banner__title">Настройки cookie</p>
                <p className="cookie-banner__text">
                    Для работы сайта используются необходимые cookie. С вашего согласия могут
                    подключаться аналитические cookie (см.{' '}
                    <a href="/conf-policy/">политику конфиденциальности</a>).
                </p>
                <label className="cookie-banner__checkbox">
                    <input
                        type="checkbox"
                        checked={analyticsEnabled}
                        onChange={(e) => setAnalyticsEnabled(e.target.checked)}
                    />
                    <span>Разрешить аналитические cookie</span>
                </label>
                <div className="cookie-banner__actions">
                    <button type="button" className="button button--ghost" onClick={() => apply(false)}>
                        Только необходимые
                    </button>
                    <button type="button" className="button button--ghost" onClick={() => apply(analyticsEnabled)}>
                        Сохранить выбор
                    </button>
                    <button type="button" className="button button--primary" onClick={() => apply(true)}>
                        Принять все
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsentBanner;
